// extracted by mini-css-extract-plugin
export default {"arrows":"ScrollMore_arrows__j9tAO","arrow":"ScrollMore_arrow__nAxAE","a1":"ScrollMore_a1__-gf18","a2":"ScrollMore_a2__Rr29g","a3":"ScrollMore_a3__iUuYP"};